import React, { useEffect, useState } from 'react'
import { stateObjType } from '../types';
import { getMethodService } from '../services';
import { CHECKED_CALL_API, DOWNLINE_COUNT_NODE_API, MEMBER_OUTSTANDING_NODE_API } from '../services/constants';
import { HandleLogout, amountCommasSparated, decodeData } from '../utils/Helper';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import TableScroll from '../utils/TableScroll';
import Template from '../utils/Template';
import TableLoading from '../utils/TableLoading';
import { useQuery } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';
import { userIdHandler } from '../store/slices/userIdSlice';
import ScreenLoader from '../utils/ScreenLoader';
const Cookies = require('js-cookie');

let totalFetch = 0;
let totalFetchPage = 0;

const StockMemberOutstanding = () => {
    const abortController = new AbortController();
    var checkTime = new Date();
    var actualDate = new Date();
    var footballDate = new Date();
    checkTime.setHours(10); checkTime.setMinutes(29);

    if(actualDate.getTime() < checkTime.getTime()){
        footballDate.setDate(footballDate.getDate() - 1);
    }

    const year = footballDate.getFullYear();
    const month = String(footballDate.getMonth() + 1).padStart(2, "0");
    const day = footballDate.getDate();


    const tomorrowDate = new Date(footballDate);
    tomorrowDate.setDate(tomorrowDate.getDate() + 1);
    const tomorrowYear = tomorrowDate.getFullYear();
    const tomorrowMonth = String(tomorrowDate.getMonth() + 1).padStart(2, "0");
    const tomorrowDay = String(tomorrowDate.getDate()).padStart(2, "0");

    const today = `${year}-${month}-${day.toString().padStart(2, "0")} 10:29`;
    const tomorrow = `${tomorrowYear}-${tomorrowMonth}-${tomorrowDay} 10:28`;
    const currentDay = `${year}-${month}-${day.toString().padStart(2, "0")}`;

    const [outstandings, setOutstandings] = useState<stateObjType>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isDownlineLoading, setIsDownlineLoading] = useState(false);
    const navigate = useNavigate();
    const [downlineCount,setDownlineCount] = useState<any>(null);
    const [checkedAdminId,setCheckedAdminId] = useState<any>(null)
    const { temp_user_id } = useSelector((state: any) => state.userId);
    const dispatch = useDispatch();
    const [role,setRole] = useState("");
    let roles = ['admin','super','senior'];

    useEffect(()=>{
        const getAuth = Cookies.get("n_a_u");
        let decode = getAuth && decodeData(getAuth);
        if(decode){
        let findRole = roles.includes(decode?.role_name);
        if(findRole){
            getMethodService(`${CHECKED_CALL_API}?message=${decode?.role_name}(${decode?.type}) view win-lose report from ${today} to ${tomorrow}`,{},false,decode?.token)
            .then((res) => {
            if (res == 401) {
                HandleLogout(navigate);
            };
            if (res?.status === "success") {
                
            };
            });
        };
        };
    },[]);


    const fetchDownlinesCount = (abortController:any) => {
        const getAuth = Cookies.get("n_a_u");
        setIsDownlineLoading(true);
        let decode = decodeData(getAuth);
        getMethodService(`${DOWNLINE_COUNT_NODE_API}?user_id=${decode?.user_id}`,{},false,decode?.token,abortController)
          .then((res) => {
            setIsDownlineLoading(false);
            if (res == 401) {
              HandleLogout(navigate);
            }
            if (res?.status === "success") {
              setDownlineCount(res?.data);
            }
          })
          .catch((err) => {
            console.log(err);
            setIsDownlineLoading(false);
          });
    };

    // const fetchMemberOutstand = () => {
    //     const getAuth = Cookies.get('n_a_u');
    //     if(getAuth){
    //         let decode = decodeData(getAuth);
    //         return getMethodService(`${MEMBER_OUTSTANDING_NODE_API}?start_date=${today}&end_date=${tomorrow}&sort_column=usercode`,{},false,decode?.token,abortController);
    //     };
    // }
    // const memberOutstandQuery = useQuery({ queryKey: ['memberOutstand'], queryFn: fetchMemberOutstand, refetchOnWindowFocus: false});

    // useEffect(()=>{
    //     if(memberOutstandQuery){
    //         setIsLoading(memberOutstandQuery.isLoading);
    //         if(memberOutstandQuery?.data == 401){
    //             HandleLogout(navigate);
    //         };
    //         if(memberOutstandQuery?.data?.status === "success"){
    //             // setOutstandings();
    //             console.log(memberOutstandQuery?.data?.data)
    //         }
    //     };
    // },[memberOutstandQuery]);

    useEffect(() => {
        const getAuth = Cookies.get("a_u");
        let decode = getAuth && decodeData(getAuth);
        if (decode) {
          setRole(decode?.role_name)
          if (temp_user_id?.length > 0) {
            setCheckedAdminId(temp_user_id[temp_user_id.length - 1]);
          } else {
            dispatch(userIdHandler([decode?.user_id]));
            setCheckedAdminId(decode?.user_id);
          }
        }
      }, []);

    const fetchOutstandingData = async (page: number, limit: number) => {
        const getAuth = Cookies.get("n_a_u");
        if (getAuth) {
            // if (userId) {
            let decode = decodeData(getAuth);
            setIsLoading(true);
            return getMethodService(`${MEMBER_OUTSTANDING_NODE_API}?start_date=${today}&end_date=${tomorrow}&sort_column=usercode&page=${page}&limit=${limit}`,{},false,decode?.token,abortController)
                .then((res) => {
                if(res == 455){
                    return 455;
                }
                if (res == 401) {
                    HandleLogout(navigate);
                };
                if (res?.status === "success") {
                    totalFetch = +totalFetch+1;
                    let result = res?.data;
                    if (totalFetchPage == totalFetch) {
                        setIsLoading(false)
                    }

                    setOutstandings((prevReports:any) => {
                    const updatedReports = [...prevReports, ...result];

                    // Sort the updatedReports array by usercode
                    updatedReports.sort((a, b) =>
                        a.usercode.localeCompare(b.usercode)
                    );

                    return updatedReports;
                    });
                } else {
                    console.log("res",res)
                    console.log("report api  error response..");
                    fetchOutstandingData(page, limit);
                }

                // setIsLoading(false);
                })
                .catch((err) => {
                    console.log("report api requet fail ..", err);
                    fetchOutstandingData(page, limit);
                // setIsLoading(false);
                });
            // }
        };
    };

    const fetAllOutstandingData = async() => {
        setOutstandings([]);
        if (downlineCount?.count) {
          const concurrencyLimit = 1;
          let promises: any = [];
          let limit = 100000;
          let page =1;
          if(checkedAdminId == 1 || role === 'admin'){
             limit =  5;
             page = Math.ceil(downlineCount?.count / limit);
          };
          for (let i = 1; i <= page; i++) {
            if(window.location.pathname !== '/stock-manage/member-outstanding'){
               break;
            };
            promises.push(fetchOutstandingData(i, limit));
            if (promises.length >= concurrencyLimit) {
              let res = await Promise.all(promises);
              if(res.includes(455)){
                break;
              };
              promises.length = 0; // Clear the array for the next batch
            };
          };
          setIsLoading(false);
        };
    };

    useEffect(() => {
        const abortController = new AbortController();
        fetAllOutstandingData();
        return () => {
            abortController.abort();
        };
    }, [ downlineCount]);


    useEffect(()=>{
        return () => {
            abortController.abort();
        }
    },[]);

    useEffect(() => {
        const abortController = new AbortController();
        fetchDownlinesCount(abortController);
        return () => {
            abortController.abort();
        };
    }, []);

  return (
    <>  
        <Template title='Stock Management'>
            <div className="card mb-3 mb-lg-5">
                <div className="card-header">
                    <div className="row align-items-center">
                        <div className="col-sm-5">
                            <h4 className="card-title">
                                Member Oustanding
                            </h4>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-lg-8">
                            <TableScroll>
                                <div>
                                    <table className="table text-white w-100 table-bordered table-striped">
                                        <thead>
                                            <tr style={{backgroundColor: '#25282a'}}>
                                                <th className="p-2 text-center text-light">No</th>
                                                <th className="p-2 text-center text-light">Account</th>
                                                <th className="p-2 text-center text-light">Total Outstanding</th>
                                                <th className="p-2 text-center text-light">Body Outstanding</th>
                                                <th className="p-2 text-center text-light">Parlay Outstanding</th>
                                                <th className="p-2 text-center text-light">3D Outstanding</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {/* {isLoading && <TableLoading col={5} />} */}
                                            {
                                                outstandings.length > 0 ?
                                                outstandings.map((outstanding:stateObjType,i: number) =>(
                                                    <tr style={{verticalAlign: 'middle'}} key={i}>
                                                        <td className="p-2 text-center text-dark">{i + 1}</td>
                                                        <td className="p-2 text-center text-dark">{outstanding.usercode}</td>
                                                        <td className="p-2 text-end text-dark">
                                                        {outstanding.role_id == 6 ? (
                                                            <Link
                                                                to={`/stock-manage/member/betting-list/${outstanding.user_id}/pending/${currentDay}/${currentDay}`}
                                                            >
                                                                <b>
                                                                    {
                                                                        amountCommasSparated(outstanding.oustanding)
                                                                    }
                                                                </b>
                                                            </Link>
                                                        ) : (
                                                            <Link
                                                                to={`/stock-manage/member-outstanding/${outstanding.user_id}`}
                                                            >
                                                                <b>
                                                                    {
                                                                        amountCommasSparated(parseInt(outstanding.oustanding))
                                                                    }
                                                                </b>
                                                            </Link>
                                                        )}
                                                        </td>
                                                        <td className='p-2 text-end text-dark'><b>{amountCommasSparated(outstanding.body_oustanding)}</b></td>
                                                        <td className='p-2 text-end text-dark'><b>{amountCommasSparated(outstanding.perlay_oustanding)}</b></td>
                                                        <td className='p-2 text-end text-dark'><b>{amountCommasSparated(outstanding.threed_oustanding)}</b></td>
                                                    </tr>
                                                )):
                                                <tr>
                                                    <td className='text-center' colSpan={6}>No found data</td>
                                                </tr>
                                            }
                                        </tbody>
                                        {
                                            outstandings?.length > 0 &&
                                            <tfoot>
                                                <tr style={{backgroundColor: '#25282a'}}>
                                                    <th className="p-2 text-end text-light" colSpan={2}>Total :</th>
                                                    <td style={{fontSize: '13px'}} className="text-end text-white p-2"><b>{outstandings.reduce((a:any,v:any) =>  a = a + v?.oustanding , 0 ).toLocaleString()}</b></td>
                                                    <th className="p-2 text-center text-light" colSpan={3}></th>
                                                </tr>
                                            </tfoot>
                                        }
                                    </table>
                                </div>
                            </TableScroll>
                        </div>
                    </div>
                </div>
            </div>
        </Template>
        <ScreenLoader isLoading={isLoading || isDownlineLoading} />
        <ToastContainer />
    </>
  )
}

export default StockMemberOutstanding
